import { alpha } from '@mui/material/styles';

const CALLOUT_BORDER_ALPHA = 0.4;
const CALLOUT_BG_ALPHA = 0.08;

export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '20px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const titleStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const rowsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
};

export const rowLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const getStatusCalloutStyles = isReady => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '12px 14px',
  borderRadius: '8px',
  border: ({ palette }) =>
    `1px solid ${alpha(isReady ? palette.success.main : palette.error.main, CALLOUT_BORDER_ALPHA)}`,
  backgroundColor: ({ palette }) =>
    alpha(isReady ? palette.success.main : palette.error.main, CALLOUT_BG_ALPHA),
  color: ({ palette }) => (isReady ? palette.success.main : palette.error.main),
});

export const calloutIconStyles = {
  display: 'flex',
  flexShrink: 0,
  marginTop: '1px',
};
